
export default [
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/mainIndex"),
    meta: {
      title: "九斗竞赛网"
    }
  },
  {
    path: "/competitionNavigation",
    name: "competitionNavigation",
    component: () => import("@/views/competitionNavigation"),
    meta: {
      title: "九斗竞赛网"
    }
  },
  {
    path: "/competitionNavigation/detail",
    name: "competitionNavigationDetail",
    component: () => import("@/views/competitionNavigationDetail"),
    meta: {
      title: "九斗竞赛网"
    }
  },
  {
    path: "/competitionService",
    name: "competitionService",
    component: () => import("@/views/competitionService"),
    meta: {
      title: "九斗竞赛网"
    }
  },
  {
    path: "/competitionService/detail",
    name: "competitionServiceDetail",
    component: () => import("@/views/competitionServiceDetail"),
    meta: {
      title: "九斗竞赛网"
    }
  },
  {
    path: "*", // 访问页面路径不存在，重定向到首页
    redirect: "/index",
  },
];
